import Vue from "vue";
import auth from "@/auth/auth.js";
import VueCookie from "vue-cookie";

const state = {
  user: {},
  token: null
};

const getters = {};

const actions = {
  LOGIN: function({ commit }, payload) {
    return Vue.prototype.$axios
      .post(
        "/auth/token",
        {},
        {
          auth: {
            username: payload.email,
            password: payload.password
          }
        }
      )
      .then(
        async response => {
          return await auth
            .setToken(response.data.token, response.data.expiry)
            .then(data => {
              if (auth.tokenIsValid(response.data.token)) {
                VueCookie.set("token", response.data.token);
                Vue.prototype.$axios.defaults.headers.common.Authorization = `Bearer ${VueCookie.get(
                  "token"
                )}`;
                commit("SET_USER", auth.decodeToken(response.data.token));
                return response;
              }
              return Promise.reject(new Error("Token is invalid"));
            });
        },
        err => {
          throw new Error(err);
        }
      );
  }
};

const mutations = {
  SET_USER(state, user) {
    state.user = user;
  },
  SET_TOKEN(state, token) {
    state.token = token;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
